import { put, select, takeEvery } from 'redux-saga/effects';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ISystemInoperabilityResponse } from 'ApiPackage/NewsModule/interfaces/ISystemInoperabilityResponse';
import { fetchSystemInoperabilityList } from 'ApiPackage/NewsModule/services/systemInoperability';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import { SystemInoperabilityActionsEnum } from '../enums/SystemInoperabilityActionsEnum';
import { getList, getListPage, getOrder } from '../selectors/systemInoperabilitySelectors';
import { setSystemInoperabilityList } from '../actions/systemInoperabilityAction';

export function* systemInoperabilitySaga() {
  yield takeEvery(SystemInoperabilityActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST, getSystemInoperabilityListSaga);
  yield takeEvery(
    SystemInoperabilityActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE,
    getSystemInoperabilityListNextPageSaga,
  );
}

function* getSystemInoperabilityListSaga() {
  const state: IRootState = yield select();
  const sort = getOrder(state);

  function* funcTry() {
    const data: ISystemInoperabilityResponse = yield fetchSystemInoperabilityList(sort, 0);

    yield put(setSystemInoperabilityList(data.list, data.page, data.pageCount, data.totalCount));
  }
  yield sagaWrapper({
    funcTry,
  });
}

function* getSystemInoperabilityListNextPageSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const sort = getOrder(state);
    const page = getListPage(state);
    const list = getList(state);

    const data: ISystemInoperabilityResponse = yield fetchSystemInoperabilityList(sort, page + 1);

    yield put(setSystemInoperabilityList([...list, ...data.list], data.page, data.pageCount, data.totalCount));
  }

  yield sagaWrapper({
    funcTry,
  });
}
